module.exports = __webpack_public_path__ + "img/huangguan.f17eed38.png";